import styles from './LegalCapacity.module.scss';

import BackButton from "@src/components/_shared/BackButton";
import Container from "@src/components/_shared/Container";
import BlockTitle from "@src/components/_shared/UI/BlockTitle";
import useNavigationStore from "@src/stores/navigationStore";
import useRegistrationStore from "@src/stores/registrationStore";
import { useQuery } from '@tanstack/react-query';
import { getReferencialData } from '@src/api/Referencial';
import { useState } from 'react';
import WarningModal from '@src/components/_shared/WarningModal';
import VirtualAssistant from '@src/assets/VirtualAssistant.png';
import Loader from '@src/components/_shared/UI/Loader';
import Subtitle from '@src/components/_shared/UI/Subtitle';
import PictureButton from '@src/components/_shared/UI/PictureButton';
import { getPhoneNumber } from '@src/utilities/functions';


export default function LegalCapacity() {
    const { setSection, setBlock } = useNavigationStore();
    const { setField, registration } = useRegistrationStore();
    const [showModal, setShowModal] = useState<boolean>(false)

    const { data, isLoading } = useQuery({ 
        queryKey: [`legalCapacities`],
        queryFn: () => getReferencialData({type: 'legal-capacities'})
    });

    const _onGoBack = () => {
        setSection(2)
        setBlock('Birth')
    };

    const _onValidate = () => {
        setField('person.legal.legal_capacity', Object.keys(data)[0])
        setBlock('Nationality');
    };

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Capacité juridique" />
            <Subtitle content="Veuillez indiquer si vous êtes un majeur sans restriction ou un majeur incapable" />
            {isLoading ? <Loader type='SPINNER' /> : null}
            {data ?
                <div className={styles.buttonContainer}>
                    <PictureButton type='majeur' onClick={_onValidate} />
                    <PictureButton type='incapable' onClick={() => setShowModal(!showModal)} />
                </div>
                : null}
            {showModal ?
                <WarningModal
                    image={VirtualAssistant}
                    show={showModal}
                    content={`En raison de votre statut de majeur protégé, l'ouverture de compte en ligne n'est pas possible. Nous vous invitons à contacter le service de la relation client au ${getPhoneNumber(registration.partner_informations.is_partner, registration.partner_informations.brand.code)}.`}
                    onValidate={() => setShowModal(false)}
                />
                : null}
        </Container>
    )
}
